import 'bootstrap/dist/js/bootstrap.bundle.js';
import Modal from './modal';
import { NotificationHandlerHelper } from '../helpers/notification-handler-helper';

const modal = new Modal();
modal.modalClickListener('[data-show-modal]');

if (window.showResetPasswordModal) {
    modal.open(
        window.route(
            'frontend.modal.reset-password',
            {
                token: window.resetPasswordToken,
                email: window.resetPasswordEmail,
            },
        ),
    );
}
else if (window.showLoginModal) {
    modal.open(window.route('frontend.modal.login'));
}

NotificationHandlerHelper.init();
